
export const StringValidation = {
    /* This file contains custom validation utility functions to validate string values alone 
sample scenarios are below
 isNullOrEmpty("")         // true
 isNullOrEmpty("  ")       // true
 isNullOrEmpty(null)       // true
 isNullOrEmpty(undefined)  // true
 isNullOrEmpty("valid")    // false
*/
    isNullOrEmpty(value?: string | null): boolean {
        return !value || value.trim() === "";
    }
};

export const RestrictedDataValidation = {
    /* This file contains validation utility functions to check for restricted data values
sample scenarios are below
 isRestrictedData("NA")           // true
 isRestrictedData("N/A")          // true
 isRestrictedData("Not available") // true
 isRestrictedData("n/a")          // true
 isRestrictedData("valid data")   // false
 isRestrictedData("")             // false
*/
    isRestrictedData(value?: string | null,disallowNulls=false): boolean {
        if (!value) return false;
        
        const restrictedValues = [
            "NA",
            "N/A", 
            "Not available",
            "n/a",
            ...disallowNulls?["null"]:[]
        ];
        
        const trimmedValue = value.trim();
        return restrictedValues.includes(trimmedValue);
    }
};
